// INTEL CONFIDENTIAL
// Copyright (C) 2023 Intel Corporation

import { graphql, useStaticQuery } from 'gatsby'

export const useSiteMetadata = () => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          siteTitle
          description
          siteUrl
          image
          orgDescription
        }
      }
    }
  `)

  return data.site.siteMetadata
}
